import { render, staticRenderFns } from "./ChangeCategoryModal.vue?vue&type=template&id=20323e56&scoped=true"
import script from "./ChangeCategoryModal.vue?vue&type=script&lang=js"
export * from "./ChangeCategoryModal.vue?vue&type=script&lang=js"
import style0 from "./ChangeCategoryModal.vue?vue&type=style&index=0&id=20323e56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20323e56",
  null
  
)

export default component.exports